import { Directive, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Directive({
  selector: '[atxOnDestroy]',
  standalone: true,
})
export class AtaraxiaOnDestroyDirective implements OnDestroy {
  private destroy$$ = new ReplaySubject<void>(1);

  public destroy$ = this.destroy$$.asObservable();

  public ngOnDestroy() {
    this.destroy$$.next();
    this.destroy$$.complete();
  }
}
